import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { linksRouter } from "../../../config/RouterLink";
import { useDispatch, useSelector } from "react-redux";
//Antd
import { Col, Row, Typography, Button } from "antd";

/**Redux-Ducks */
import {
  obtenerSistemaINE,
  obtenerSistemaOPLE,
} from "../../../redux/consultavacantes/sistemasDucks";

import { limpiarDatos } from "../../../redux/consultavacantes/consultaVacantesDucks";
import {
  cleanFunciones,
  cleanRequisitosINE,
  cleanObjetivosINE,
  cleanFuncionesINE,
  cleanRequisitos,
  cleanObjetivos,
} from "../../../redux/consultavacantes/descripcionpuestoDucks";

const { Text } = Typography;

export const DeclinadaPage = () => {
  const { nombreConcurso, nombreConvocatoria, idSistema, vacanteDetalle } =
    useSelector((state) => state.consultaVacantes);

  const dispatch = useDispatch();
  const history = useHistory();

  //const experiencia = localStorage.getItem("experiencia");
  //const experienciaine = localStorage.getItem("experienciaine");

  useEffect(() => {
    dispatch(obtenerSistemaINE());
    dispatch(obtenerSistemaOPLE());
  }, [dispatch]);

  //Se limpia el state de Consulta Vacantes
  useEffect(() => {
    return () => {
      dispatch(limpiarDatos());
      dispatch(cleanObjetivos({}));
      dispatch(cleanFunciones({}));
      dispatch(cleanRequisitos({}));
      dispatch(cleanObjetivosINE({}));
      dispatch(cleanFuncionesINE({}));
      dispatch(cleanRequisitosINE({}));
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const Postulaciones = () => {
    history.push(linksRouter.postulaciones);
  };

  const Vacantes = () => {
    history.push(linksRouter.vacanteslogin);
  };

  return (
    <>
      <div className="layout-content-public">
        <Row style={{ marginBottom: "10px" }}>
          <Col span={24}>
            <Text style={{ fontSize: "28px", fontWeight: 400 }}>
              Mi Postulación
            </Text>
          </Col>
        </Row>

        <Row>
          <Col span={12}>
            <Row>
              <Col span={12}>
                <Text style={{ fontSize: "16px", fontWeight: 400 }}>
                  Concurso
                </Text>
                <br />
                {idSistema === 1 && (
                  <Text style={{ fontSize: "18px" }}>{nombreConcurso}</Text>
                )}
                {idSistema === 2 && (
                  <Text style={{ fontSize: "18px" }}>{nombreConcurso}</Text>
                )}
              </Col>

              <Col span={12}>
                <Text style={{ fontSize: "16px", fontWeight: 400 }}>
                  Convocatoria
                </Text>
                <br />
                {idSistema === 1 && (
                  <Text style={{ fontSize: "18px" }}>{nombreConvocatoria}</Text>
                )}
                {idSistema === 2 && (
                  <Text style={{ fontSize: "18px" }}>{nombreConvocatoria}</Text>
                )}
              </Col>
            </Row>
          </Col>
        </Row>
        <br />
        <Row>
          <Col span={4}>{/*Imagen del lado izquierdo*/}</Col>
          <Col span={20}>
            <Text style={{ fontSize: "26px" }}>¡UPS! </Text>
            <br />
            {idSistema === 1 && (
              <Text style={{ fontSize: "18px" }}>
                Tu solicitud para la postulación del cargo/puesto: &nbsp;
                <b>{vacanteDetalle.nombretipo}</b> incumple los requisitos
                conforme a lo señalado en las cédulas de cargo/puesto del
                catálogo del SPEN.
              </Text>
            )}
            {idSistema === 2 && (
              <Text style={{ fontSize: "18px" }}>
                Tu solicitud para la postulación del cargo/puesto: &nbsp;
                <b>{vacanteDetalle.denominacion}</b> incumple los requisitos
                conforme a lo señalado en las cédulas de cargo/puesto del
                catálogo del SPEN.
              </Text>
            )}
            <br />
            <br />
            <Text style={{ fontSize: "18px" }}>
              Te sugerimos postularte para otra vacante.
            </Text>
            <br />
            <br />
          </Col>
        </Row>

        <Row>
          <Col offset={12} span={12}>
            <Row>
              <Col span={12}>
                <Button
                  style={{
                    borderRadius: "7px",
                    fontSize: "18px",
                    height: "100%",
                    width: "90%",
                  }}
                  htmlType="submit"
                  onClick={Vacantes}
                >
                  Ir a vacantes
                </Button>
              </Col>
              <Col span={12}>
                <Button
                  style={{
                    borderRadius: "7px",
                    fontSize: "18px",
                    height: "100%",
                    width: "90%",
                  }}
                  htmlType="submit"
                  onClick={Postulaciones}
                >
                  Ver mis postulaciones
                </Button>
              </Col>
            </Row>
          </Col>
        </Row>
      </div>
    </>
  );
};
